import { createRootRoute, Outlet, redirect, useLocation, useMatchRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { telemetry } from '../utils/telemetry';
// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import DexHeader from '../components/header/dex_header.tsx';
import DexFooter from '../components/footer/dex_footer.tsx';
import { ErrorBoundary } from '@/components/error_boundary.tsx';
import { useGeneralShortcuts } from '../features/shortcuts';
import useAuthStore from '../store/rootStore.ts';

type searchParams = { ref?: string };

export const Route = createRootRoute({
  component: RootComponent,
  pendingComponent: () => <div>Loading...</div>,
  notFoundComponent: () => {
    redirect({ to: '/trade' });
    return null;
  },
  validateSearch: (search: Record<string, unknown>): searchParams => {
    return {
      ref: search.ref as string,
    };
  },
  beforeLoad: ({ location, search }) => {
    const { ref } = search;

    if (ref) {
      useAuthStore.getState().saveInviteCode(ref);

      throw redirect({
        to: location.pathname,
        search: (prev: searchParams) => {
          const { ref: _, ...rest } = prev;
          return rest;
        },
        replace: true,
      });
    }

    if (location.pathname === '/') {
      throw redirect({
        to: '/trade',
        replace: true,
      });
    }
  },
});

function RootComponent() {
  const location = useLocation();
  const matchRoute = useMatchRoute();
  useGeneralShortcuts(!!matchRoute({ to: '/trade/$marketSymbol' }));

  useEffect(() => {
    telemetry.logPageView(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ErrorBoundary>
        <DexHeader />
      </ErrorBoundary>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      {/*<TanStackRouterDevtools position="top-left" />*/}
      <ErrorBoundary>
        <DexFooter />
      </ErrorBoundary>
    </>
  );
}
